@import "~@govbr-ds/core/src/components/breadcrumb/breadcrumb";
@import "~@govbr-ds/core/src/partial/scss/configs/icons";
@import "~@govbr-ds/core/src/components/button/button";
@import "~@govbr-ds/core/src/components/list/list";
@import "~@govbr-ds/core/src/components/item/item";
@import "~@govbr-ds/core/src/components/divider/divider";

:host {
  display: block;
  position: relative;
}

.br-breadcrumb {
  .br-icon {
    color: #ccc;
  }

  .br-icon,
  .mobile-active-page {
    display: flex;
    align-items: center;
  }

  .mobile-crumb-list {
    display: none;
    position: absolute;
    width: 200px;
    box-shadow: var(--surface-shadow-sm);
    --interactive: var(--color);
    --interactive-rgb: var(--color-rgb);
  }

  .mobile-crumb-list.show {
    display: block;
    top: 100%;
    z-index: 999;
  }

  .buttonFolderGroup,
  .buttonFolderGroup span {
    display: flex;
    align-items: center;
  }

  .mobile-active-page {
    span:focus:focus-visible {
      outline: var(--focus-width) var(--focus-style) var(--focus);
      outline-offset: var(--focus-offset);
    }

    [data-active] {
      margin: 0 var(--spacing-scale-2x) 0 var(--spacing-scale-base);
    }
  }

  .crumb {
    display: flex;
    align-items: center;

    span {
      display: flex;
      align-items: center;
    }
  }
}

.tooltip-box {
  position: absolute;
  background: #1351b4;
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  max-width: calc(100vw - 32px);
  white-space: normal;
  overflow-wrap: break-word;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 2px 4px rgb(0 0 0 / 20%);
  width: max-content;

  &[data-placement^="top"] {
    .tooltip-arrow {
      bottom: -4px;
    }
  }

  &[data-placement^="bottom"] {
    .tooltip-arrow {
      top: -5px;
    }
  }

  &[data-placement^="left"] {
    .tooltip-arrow {
      right: -4px;
    }
  }

  &[data-placement^="right"] {
    .tooltip-arrow {
      left: -4px;
    }
  }

  .tooltip-arrow {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #1351b4;
    transform: rotate(45deg);
  }
}
